<script setup>
import { storeToRefs } from 'pinia'
const { filteredCars, loading, error, dtcActive } = storeToRefs(useCarStore())

</script>

<template>
  <div class="container">
    <div class="row gx-5 align-items-start">
      <div class="col-lg-3 m-0">
        <h1 class="mb-2 d-none d-md-block">Filteren</h1>
        <div class="crc-filter-container d-none d-lg-block" id="crc-filter">
          <div class="crc-filter">
            <div class="d-flex justify-content-between mb-3">
              <h3 class="mb-0">Zoeken</h3>
              <h3 class="mb-0 cursor-pointer" @click="resetfilters"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg> Reset</h3>
            </div>
            <div class="searchbar-container mt-2">
              <input type="search" placeholder="Merk of model" v-model="searchquery">
            </div>
          </div>
          <div class="crc-filter" v-for="(filter, i) in (Object.keys(sortedFilters).length ? sortedFilters.filter(x => x.key !== 'model') : [])" v-bind:key="i">
            <div :class="'d-flex justify-content-between align-items-center honda-filter-dropdown' + (filter.options.filter(x => x.selected === true).length > 0 ? ' active ' : '')" :data-filter-id="'desktop'+filter.key">
              <h3 class="mb-0">{{  filter.title ?? filter.key }}</h3>
              <svg class="" width="16px" height="14px"><use xlink:href="#Icon--chevron-down"></use></svg>
            </div>
            <ul class="collapse mt-2" :id="'desktop'+filter.key" :style="filter.options.filter(x => x.selected === true).length > 0 ? 'display:block' : ''">
              <!-- Speciale behandeling voor 'Prijs' filter -->
              <div v-if="filter.key.match(/^verkoopprijs_particulier.*/)" class="row">
                <div class="col-6">
                  <div class="form-group">
                    <input type="text"
                           class="form-control"
                           :value="displayMinVal(filter)"
                           @input="updateMinVal(filter, $event.target.value)"
                           :placeholder="'Van €....'">
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <input type="text"
                           class="form-control"
                           :value="displayMaxVal(filter)"
                           @input="updateMaxVal(filter, $event.target.value)"
                           :placeholder="'Tot €....'">
                  </div>
                </div>
              </div>

              <div v-if="filter.type === 'optionlist'">
                <li v-for="(option) in filter.options" v-bind:key="option.title">
                  <input type="checkbox" :id="option.title + '-' + filter.key" :name="option.title + '-' + filter.key" :true-value="true" v-model="option.selected">
                  <label :for="option.title +'-' + filter.key" v-if="filter.key === 'btw_marge' && option.title == 'B'">BTW<span></span></label>
                  <label :for="option.title +'-' + filter.key" v-if="filter.key === 'brandstof' && option.title == 'H'">Hybride<span></span></label>
                  <label :for="option.title +'-' + filter.key" v-if="(filter.key !== 'btw_marge' || filter.key === 'btw_marge' && option.title != 'B') && (filter.key !== 'brandstof' || filter.key === 'brandstof' && option.title != 'H')">{{ filter.prefix }} {{ translateDict[option.title] ?? option.title }} {{ filter.suffix }}<span></span></label>
                  <div v-if="filter.key === 'merk' && option.selected === true" class="honda-filter-sub">
                    <div  v-for="model in filters.find(x => x.key === 'model').options.filter((x) => {
                        return carStore.cars.filter(z => z.mappeddata.brand === option.title && z.extradata.model === x.title).length > 0;
                                                  }).sort((a, b) => (a.title > b.title) ? 1 : -1)" v-bind:key="model">
                      <input type="checkbox" :id="model.title" :name="model.title" :true-value="true" v-model="model.selected">
                      <label :for="model.title">{{  model.title }}<span></span></label>
                    </div>
                  </div>
                </li>
              </div>
              <div v-if="filter.type === 'minmax' && !filter.key.match(/^verkoopprijs_particulier.*/)" class="row">
                <div class="col-6">
                  <div class="form-group">
                    <select v-model="filter.minval" class="form-select">
                      <option v-for="opt in filter.options" :key="opt.title" :value="opt.title">{{ filter.prefix }} {{ opt.title }} {{ filter.suffix }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <select v-model="filter.maxval" class="form-select col-6">
                      <option v-for="opt in filter.options" :key="opt.title" :value="opt.title">{{ filter.prefix }} {{ opt.title }} {{ filter.suffix }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
        <a href="#" class="crc-filterbutton crc-filterbutton-top d-lg-none" @click="filtersopen = true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"/></svg>Filteren</a>
        <div class="crc-filter-container d-lg-none" id="crc-filter" v-if="filtersopen === true">
          <a href="#" class="crc-filterbutton close d-md-none" @click="filtersopen = false">Sluiten</a>
          <div class="crc-filter" v-if="filtersopen">
            <div class="d-flex justify-content-between mb-3">
              <h3 class="mb-0">Zoeken</h3>
              <h3 class="mb-0 cursor-pointer" @click="resetfilters"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg> Reset</h3>
            </div>
            <div class="searchbar-container mt-2">
              <input type="search" placeholder="Merk of model" v-model="searchquery">
            </div>
          </div>
          <div class="crc-filter" v-for="(filter, i) in (Object.keys(sortedFilters).length ? sortedFilters.filter(x => x.key !== 'model') : [])" v-bind:key="i">
            <div class="d-flex justify-content-between align-items-center honda-filter-dropdown" :data-filter-id="filter.key">
              <h3 class="mb-0">{{  filter.title ?? filter.key }}</h3>
              <svg class="" width="16px" height="14px"><use xlink:href="#Icon--chevron-down"></use></svg>
            </div>
            <ul class="collapse mt-2" :id="filter.key">
              <!-- Speciale behandeling voor 'Prijs' filter -->
              <div v-if="filter.key.match(/^verkoopprijs_particulier.*/)" class="row">
                <div class="col-6">
                  <div class="form-group">
                    <input type="text"
                           class="form-control"
                           :value="displayMinVal(filter)"
                           @input="updateMinVal(filter, $event.target.value)"
                           :placeholder="'Van €....'">
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <input type="text"
                           class="form-control"
                           :value="displayMaxVal(filter)"
                           @input="updateMaxVal(filter, $event.target.value)"
                           :placeholder="'Tot €....'">
                  </div>
                </div>
              </div>

              <div v-if="filter.type === 'optionlist'">
                <li v-for="(option) in filter.options" v-bind:key="option.title">
                  <input type="checkbox" :id="option.title + '-' + filter.key" :name="option.title + '-' + filter.key" :true-value="true" v-model="option.selected">
                  <label :for="option.title + '-' + filter.key" v-if="filter.key === 'btw_marge' && option.title == 'B'">BTW<span></span></label>
                  <label :for="option.title + '-' + filter.key" v-if="filter.key !== 'btw_marge' || filter.key === 'btw_marge' && option.title != 'B'">{{ filter.prefix }} {{ translateDict[option.title] ?? option.title }} {{ filter.suffix }}<span></span></label>
                  <div v-if="filter.key === 'merk' && option.selected === true" style="margin-left:20px;">
                    <div v-for="model in filters.find(x => x.key === 'model').options.filter((x) => {
                                                    return carStore.cars.filter(z => z.mappeddata.brand === option.title && z.extradata.model === x.title).length > 0;
                                                                              })" v-bind:key="model">
                      <input type="checkbox" :id="model.title + '-' + filter.key" :name="model.title + '-' + filter.key" :true-value="true" v-model="model.selected">
                      <label :for="model.title + '-' + filter.key">{{  model.title }}<span></span></label>
                    </div>
                  </div>
                </li>
              </div>
              <div v-if="filter.type === 'minmax' && !filter.key.match(/^verkoopprijs_particulier.*/)" class="row">
                <div class="col-6">
                  <div class="form-group">
                    <select v-model="filter.minval" class="form-select">
                      <option v-for="opt in filter.options" :key="opt.title" :value="opt.title">{{ filter.prefix }} {{ opt.title }} {{ filter.suffix }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <select v-model="filter.maxval" class="form-select col-6">
                      <option v-for="opt in filter.options" :key="opt.title" :value="opt.title">{{ filter.prefix }} {{ opt.title }} {{ filter.suffix }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </ul>
          </div>
          <a href="#" @click="filtersopen = false" class="crc-filterbutton pastoe d-lg-none">Pas filter toe</a>
        </div>
      </div>
      <div class="col-lg-9 row g-3 m-0 mt-5 mt-lg-0">
        <div class="mb-3 mt-0 d-flex justify-content-between align-items-center flex-wrap">
          <h1 class="m-0">Resultaten</h1>
          <div class="select-container">
            <select v-model="order_by">
              <option value="price_asc">Prijs laag → hoog</option>
              <option value="price_desc">Prijs hoog → laag</option>
              <option value="bouwjaar_asc">Bouwjaar laag → hoog</option>
              <option value="bouwjaar_desc">Bouwjaar hoog → laag</option>
              <option value="tellerstand_asc">Km stand laag → hoog</option>
              <option value="tellerstand_desc">Km stand hoog → laag</option>
              <option value="newly_added">Laatst toegevoegd</option>
              <option value="old_added">Eerst toegevoegd</option>
            </select>
          </div>
        </div>
        <div class="col-12">
          <h6 class="m-0">{{ filteredCars.length }} auto's</h6>
          <div v-if="dtcActive === 1"  class="geld-lenen-kost-geld-container">
            <img class="geld-lenen-kost-geld__image" src="https://voorraad-app-frontend.crc-connect.nl/build-voorraad/img/geld-lenen-kost-geld.300b48b8.svg" width="250" height="29" alt="Let op! Geld lenen kost geld">
          </div>
        </div>
        <p v-if="loading">Laden ... </p>
        <p v-if="error">{{ error.message }}</p>
        <p v-if="filteredCars.length === 0 && !loading">We hebben geen voertuigen kunnen vinden</p>
        <div class="col-lg-4 col-sm-6 d-flex cars-list" v-for="(car) in filteredCars" v-bind:key="car.extradata.autoid">
          <a :href="'https://'+domain()+'/aanbod/'+getslug(car)" class="card d-flex flex-column text-decoration-none">
            <div class="card-img-top crc-img-container">
              <img :src="car.photos[0].thumb" @click.prevent="viewCar(car)">
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col" @click.prevent="viewCar(car)">
                  <h3 class="card-title d-inline-block">{{ car.title }} </h3>
                </div>
                <a href="#/" class="col text-end" @click.prevent="togglefavorite($event, car)">
                  <i><svg class="me-2" width="20px" height="20px"><use :xlink:href="[favorites.filter(x => x === car.mappeddata.carid).length > 0 ? '#Icon--heart-filled' : '#Icon--heart']"></use></svg></i>
                </a>
              </div>
              <p class="card-text" v-html="car.mappeddata.type" @click.prevent="viewCar(car)"></p>
              <div class="card-usps d-flex flex-wrap" @click.prevent="viewCar(car)">
                <span>{{  translateDict[car.mappeddata.transmission] ?? car.mappeddata.transmission }}</span>
                <span>{{ car.mappeddata.year }}</span>
                <span>{{ car.mappeddata.milage }} km</span>
              </div>
            </div>
            <div class="vehicle-location mt-1 mb-3 ps-3" v-if="car.location">
              <span class="text-sm-start card-text">Vestiging: {{ car.location }}</span>
            </div>
            <div class="card-footer" @click.prevent="viewCar(car)">
              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex flex-wrap justify-content-between align-items-center">
                  <span>Kenteken:</span>
                  <span v-if="car.mappeddata.plate && isValidPlate(car.mappeddata.plate)">{{ car.mappeddata.plate }}</span>
                  <span v-else>n.t.b.</span>
                </li>
                <li class="list-group-item d-flex flex-wrap justify-content-between align-items-center"><span>Prijs:</span> <span>{{ formatPrice(car.mappeddata.price) }}</span></li>
                <li v-if="car.extradata.finance_term" class="list-group-item finance-container d-flex flex-wrap justify-content-between align-items-center"><span>Financieren vanaf:</span> <span>{{ formatPrice(parseInt(car.extradata.finance_term)) }}</span></li>
              </ul>
              <a :href="'https://'+domain()+'/aanbod/'+getslug(car)" @click.prevent="viewCar(car)" class="card-link btn mt-3">Bekijk auto</a>
            </div>
          </a>
        </div>
      </div>
    </div>
    <a href="#" @click="filtersopen = true" class="crc-filterbutton crc-filterbutton-sticky d-md-none"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"/></svg>Filteren</a>
  </div>
</template>

<script>
import 'jquery'
import { mapStores } from 'pinia'
import {useCarStore} from "@/stores/car";
import { isProxy, toRaw} from 'vue';
export default {
  props:['passedfilters'],
  computed: {
    ...mapStores(useCarStore),
    sortedFilters() {
      const filtersArray = Object.values(this.filters);

      return filtersArray.sort(this.sortFilters);
    }
  },
  mounted() {
    this.$parent.fromArchive = 1
    var favorites = localStorage.getItem('favorites')
    if(favorites !== null) {
      favorites = JSON.parse(favorites)
      this.favorites = favorites
    }
    const pagetitle = document.querySelector('title');

    if (pagetitle !== null) {
      if(this.$parent.$root.$data.overviewPagetitle !== '') {
        document.title = this.$parent.$root.$data.overviewPagetitle;
      } else {
        this.$parent.$root.$data.overviewPagetitle = document.title;
      }
    }

    window.jq.fn.isInViewport = function() {
      var elementTop = window.jq(this).offset().top;
      var elementBottom = elementTop + window.jq(this).outerHeight();

      var viewportTop = window.jq(window).scrollTop();
      var viewportBottom = viewportTop + window.jq(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    this.emitter.emit("restoreMeta")
    const rawFilters = toRaw(this.filters)
    if(rawFilters.length === undefined)
      this.filters = this.carStore.filters;

    window.jq(document).off('click');
    window.jq(document).on('click', '.honda-filter-dropdown', function() {
      window.jq(this).toggleClass('active');
      var id = window.jq(this).data('filter-id');
      window.jq('#' + id).slideToggle();
    });
    window.jq(document).off('resize scroll');
    window.jq(window).on('resize scroll', function() {
      if (window.jq('.crc-filterbutton-top').length > 0) {
        if (window.jq('.crc-filterbutton-top').isInViewport()) {
          window.jq('.crc-filterbutton-sticky').removeClass('visible');
        } else {
          window.jq('.crc-filterbutton-sticky').addClass('visible');
        }
      }
    });
  },
  beforeUpdate() {
    if(isProxy(this.filters)) {
      const rawFilters = toRaw(this.filters)
      if(rawFilters.length === undefined)
        this.filters = this.carStore.filters;
    }
  },
  name: "ArchivePage",
  data() {
    return {
      allfilters:null,
      availablemodels:null,
      translateDict: {
        "j":"Nieuw",
        "n":"Occasion",
        "M":"Marge",
        "B":"Benzine",
        "D":"Diesel",
        "B,E":"Benzine & Elektrisch",
        "D,E":"Diesel & Elektrisch",
        "E":"Elektrisch",
        "H":"Handgeschakeld",
        "A":"Automaat",
        "C":"CVT",
      },
      filtersopen:false,
      shownfilters:{},
      filters: {},
      brands: [],
      initialfiltersloaded:false,
      searchquery: "",
      order_by: 'newly_added',
      filteredCarsWithoutSearch: {},
      favorites: [],
    }
  },
  methods: {
    domain() {
      return window.location.host;
    },
    getslug(car) {
      return window.getslug(car);
    },
    sortFilters(a, b) {
      const order = {
        'btw_marge': 1000,
      };

      return (order[a.key] || 0) - (order[b.key] || 0);
    },
    displayMinVal(filter) {
      return filter.minval ? `€ ${filter.minval}` : '';
    },
    displayMaxVal(filter) {
      return filter.maxval ? `€ ${filter.maxval}` : '';
    },
    updateMinVal(filter, value) {
      filter.minval = value.replace('€ ', '');
    },
    updateMaxVal(filter, value) {
      filter.maxval = value.replace('€ ', '');
    },
    resetfilters() {
      this.filters.forEach(function(obj) {
        obj.minval = obj.options[0].title;
        obj.maxval = obj.options[obj.options.length-1].title;
        obj.options.forEach(function(option) {
          option.selected = false;
        });
      });
    },
    isValidPlate(plate) {
      const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6}$/;
      return regex.test(plate);
    },
    filteropenclose() {
      this.displayfilter = !this.displayfilter;
    },
    toggleFilter(filtername) {
      this.shownfilters[filtername] = !this.shownfilters[filtername]
    },
    togglefavorite(event, car)
    {
      this.carStore.toggleFavorite(car.mappeddata.carid)
      this.emitter.emit("updateFavorites", () => {
        this.getFavorites()
      })

      var favorites = localStorage.getItem('favorites')
      if(favorites !== null) {
        favorites = JSON.parse(favorites)
        this.favorites = favorites
      }
    },
    async getFavorites()
    {
      this.carStore.fetchCars();
      this.favorites  = this.carStore.getFavorites();
    },
    viewCar(car) {
      let type = car.mappeddata.type.replace(/[\W_]+/g,"-")
      let slug = car.mappeddata.slug.replace(/\D/g,"")

      this.$router.push({ name: 'DetailByModel', params: {model: window.slugify(car.mappeddata.brand) + '-' + window.slugify(car.mappeddata.model) + '-' + window.slugify(type+"-") +  window.slugify(slug) } })
    },
    formatPrice(price) {
      let euroformatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      });
      return euroformatter.format(price)
    },
  },
  watch: {
    "searchquery": {
      handler() {
        if(this.searchquery) {
          if(!this.filteredCarsWithoutSearch.length)
            this.filteredCarsWithoutSearch = this.carStore.filteredCars;

          this.carStore.filteredCars = this.filteredCarsWithoutSearch.filter((a) => a.title.toLowerCase().includes(this.searchquery.toLowerCase()));
        } else {
          this.carStore.filteredCars = this.filteredCarsWithoutSearch;
        }
      },
      deep:true
    },
    "carStore.filters": {
      handler() {
        this.filters = this.carStore.filters;
        this.availablemodels = this.carStore.filteredCars.map(x => x.extradata['model'])

        try {
          if(this.initialfiltersloaded === false)
          {

            if(!this.passedfilters)
            {
              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
              const model = urlParams.get('model')
              const merk = urlParams.get('brand')
              const price = urlParams.get('price')
              const mileage = urlParams.get('mileage')
              const location = urlParams.get('location')
              const nieuw = urlParams.get('nieuw')
              var getfilters = "";
              getfilters = this.passedfilters;

              if(merk !== null && merk !== undefined  && merk !== "")
              {
                getfilters = "&merk="+merk
              }
              if(model !== null && model !== undefined  && model !== "")
              {
                getfilters += "&model="+model
              }
              if(nieuw !== null && nieuw !== undefined  && nieuw !== "")
              {
                getfilters += "&nieuw="+(nieuw === "1" ? "j" : "n")
              }
              if(price !== null && price !== undefined && price !== "")
              {
                getfilters += "&"+this.carStore.mapped.price+"="+price
              }
              if(mileage !== "0" && mileage !== null && mileage !== undefined && mileage !== "")
              {
                getfilters += "&tellerstand="+mileage
              }
              if(location !== "0" && location !== null && location !== undefined && location !== "")
              {
                getfilters += "&klantnummer="+location
              }
            }

            if(getfilters !== "" && getfilters !== null && getfilters !== undefined) {

              var _this = this;
              var preselectedFilters = getfilters.split("&");
              preselectedFilters.forEach(function(obj) {
                var filterkey = obj.split('=')[0];
                var filtervalue = obj.split('=')[1];
                if (_this.filters.filter(x => x.key === filterkey).length === 0) {
                  console.log('filter ' + filterkey + ' bestaat niet');
                  return;
                }
                var numeric = /^-?\d+$/.test(filtervalue);
                if (numeric)
                  filtervalue = parseInt(filtervalue)

                if(_this.filters.filter(x => x.key === filterkey)[0].type === "minmax")
                {
                  _this.filters.filter(x => x.key === filterkey)[0].maxval = filtervalue;
                  var filter = _this.filters.filter(x=>x.key === filterkey)[0].options.filter(x => parseInt(x.title) === filtervalue)[0];
                  if(filter)
                    filter.selected = true;
                }

                if (_this.filters.filter(x => x.key === filterkey)[0].options.filter(x => x.title === filtervalue).length === 0) {
                  console.log('waarde bestaat niet voor filter ' + _this.filters.filter(x => x.key === filterkey)[0].key);
                  return;
                }

                filter = _this.filters.filter(x=>x.key === filterkey)[0].options.filter(x => x.title === filtervalue)[0];
                filter.selected = true;

              });

              this.initialfiltersloaded = true;
            }
          }
        } catch (error) {
          console.error(error);
        }

        // Initial filter, newly added (Chrome fix)
        this.carStore.filteredCars.sort(function (a, b) {
          return new Date(a.created_at.split("T")[0]) < new Date(b.created_at.split("T")[0]) ? 1 : -1;
        });
      },
      deep:true
    },
    order_by: {
      handler() {
        switch (this.order_by) {
          case 'price_asc':
            this.carStore.filteredCars.sort((a, b) => parseInt(a.mappeddata.price) > parseInt(b.mappeddata.price) ? 1 : -1);
            break;
          case 'price_desc':
            this.carStore.filteredCars.sort((a, b) => parseInt(a.mappeddata.price) < parseInt(b.mappeddata.price) ? 1 : -1);
            break;
          case 'tellerstand_asc':
            this.carStore.filteredCars.sort((a, b) => parseInt(a.mappeddata.milage) > parseInt(b.mappeddata.milage) ? 1 : -1);
            break;
          case 'tellerstand_desc':
            this.carStore.filteredCars.sort((a, b) => parseInt(a.mappeddata.milage) < parseInt(b.mappeddata.milage) ? 1 : -1);
            break;
          case 'bouwjaar_asc':
            this.carStore.filteredCars.sort((a, b) => parseInt(a.mappeddata.year) < parseInt(b.mappeddata.year) ? 1 : -1);
            break;
          case 'bouwjaar_desc':
            this.carStore.filteredCars.sort((a, b) => parseInt(a.mappeddata.year) > parseInt(b.mappeddata.year) ? 1 : -1);
            break;
          case 'newly_added':
            this.carStore.filteredCars.sort(function (a, b) {
              return new Date(a.created_at.split("T")[0]) < new Date(b.created_at.split("T")[0]) ? 1 : -1;
            });
            break;
          case 'old_added':
            this.carStore.filteredCars.sort(function (a, b) {
              return new Date(a.created_at.split("T")[0]) > new Date(b.created_at.split("T")[0]) ? 1 : -1;
            });
            break;
        }
      },
    },
    filters: {
      handler() {
        this.carStore.filteredCars = this.carStore.cars
        const pluck = (arr, key) => arr.map(i => i[key]);
        var _this = this;

        this.filters.forEach(function(filter) {
          if(filter.minval !== 0 || filter.maxval !== 0)
          {
            if(filter.type === 'minmax')
            {
              _this.carStore.filteredCars = _this.carStore.filteredCars.filter(function(x) {
                if(parseInt(filter.minval) !== parseInt(filter.options[0].title) || parseInt(filter.maxval) !== parseInt(filter.options[filter.options.length-1].title))
                  if(x.extradata[filter.key] === undefined)
                    return false;

                if(filter.maxval === filter.options[filter.options.length-1].title && filter.minval === filter.options[0].title )
                  return true

                return parseInt(x.extradata[filter.key]) >= parseInt(filter.minval) && parseInt(x.extradata[filter.key]) <= parseInt(filter.maxval) || x.extradata[filter.key] === undefined
              })
            }
          }

          if(filter.options.filter( x => x.selected === true).length > 0 && filter.type !== 'minmax')
          {
            _this.carStore.filteredCars = _this.carStore.filteredCars.filter( x =>
                pluck(filter.options.filter( x => x.selected === true),'title').includes(x.extradata[filter.key])
            )
          }
        });

        this.filteredCarsWithoutSearch = _this.carStore.filteredCars

        if(this.searchquery) {
          _this.carStore.filteredCars = _this.carStore.filteredCars.filter((a) => a.title.toLowerCase().includes(this.searchquery.toLowerCase()));
        }

        // Initial filter, newly added (Chrome fix)
        this.carStore.filteredCars.sort(function (a, b) {
          return new Date(a.created_at.split("T")[0]) < new Date(b.created_at.split("T")[0]) ? 1 : -1;
        });
      },
      deep: true,
      immediate: false
    }
  },
}
</script>

<style lang="scss" scoped>
.finance-container{
  background-color: #dc182c !important;
  padding: 5px 24px !important;
  margin-top: 25px;
  border-radius: 50px !important;
  color: #fff !important;
  font-weight: 500;
  border: unset !important;
  font-size: 1.1rem;
}
.geld-lenen-kost-geld-container{
  text-align: center;
  padding: 6px;
  border: 2px solid #000;
  width: 100%;
  margin-top: 14px;
  border-radius: 4px;
  background-color: #fff;
}
</style>
